// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__EM4nX","spin":"Spinner_spin__zM8-M"};